import React, { useState } from "react";
import { Button, Modal, ModalBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import { AI } from "../common/Icons";
import WebRoutes from "../pages/WebRoutes";

// Shown after the member fills in the registration form (both /register and
// /general-subscription). The organization code is optional - "Proceed" without
// one signs the member up under the default Trip Merchant organization.
const OrganizationCodeModal = ({ open, close, onProceed, loading }) => {
  const [organizationCode, setOrganizationCode] = useState("");

  const handleClose = () => {
    if (loading) return;
    close(false);
  };

  return (
    <Modal isOpen={open} toggle={handleClose} centered size="md">
      <ModalBody className="p-0 rounded-4 shadow-lg bg-white">
        <div className="modal--close-button">
          <AI.AiOutlineCloseCircle
            size={26}
            className="cursor-pointer position-absolute end-0 top-0 m-3 text-muted"
            onClick={handleClose}
          />
        </div>

        <div className="p-4 p-md-5">
          <h5 className="fw-bold text-dark mb-3">Organization Code</h5>

          <p className="text-dark mb-3">
            If you belong to an association that has a Trip Merchant partnership
            enter your organization code here, if not click on{" "}
            <strong>“Proceed”</strong>.
          </p>

          <input
            className="form-control mb-3"
            type="text"
            name="organizationCode"
            placeholder="Organization Code (optional)"
            value={organizationCode}
            onChange={(event) => setOrganizationCode(event.target.value)}
          />

          <p className="text-muted small mb-4">
            If you don’t know your organization code then email us at{" "}
            <a href="mailto:info@tripmerchant.com" className="org-code-modal-link">
              info@tripmerchant.com
            </a>{" "}
            and advise what association you belong to, or{" "}
            <Link
              to={WebRoutes.ContactUs}
              target="_blank"
              rel="noopener noreferrer"
              className="org-code-modal-link text-decoration-underline"
            >
              fill out our contact form
            </Link>
            .
          </p>

          <Button
            className="px-4 py-2 fw-bold w-100 text-white custom-primary-btn"
            disabled={loading}
            onClick={() => onProceed(organizationCode.trim())}
          >
            {loading ? <Spinner size="sm" /> : "Proceed"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OrganizationCodeModal;
